/**
 * Lo que falta antes de poder seguir · 03-11-2026
 *
 * El primer club de verdad fue a crear un grupo y el desplegable de la sede salía
 * vacío: su club no tenía ninguna, y la pantalla no decía ni que faltaba ni dónde se
 * creaba. Lo único que veía era el aviso del navegador, «Selecciona un elemento de la
 * lista», de una lista sin elementos.
 *
 * Esto va debajo de un desplegable que se ha quedado sin opciones porque falta algo
 * previo: **dice qué falta y lleva a crearlo**. Con `nuevo`, la pantalla de destino
 * abre directamente su alta; con `volver`, al guardar regresa aquí (las pantallas que
 * lo admiten: sedes, grupos y tarifas; ver `conNuevoYVolver` en las rutas).
 */
import type { ReactNode } from 'react';
import { useNavigate } from '@tanstack/react-router';

/** La ruta en que se está, para volver a ella: el camino con su consulta. */
export const aquiMismo = (): string =>
  `${window.location.pathname}${window.location.search}`;

export function FaltaAntes({
  children,
  accion,
  destino,
  nuevo = false,
  volver,
}: {
  /** Qué falta, en una frase: «Tu club todavía no tiene ninguna sede.» */
  children: ReactNode;
  /** El botón: «Añadir la primera sede». */
  accion: string;
  /** Adónde lleva: `/club/sedes`. */
  destino: string;
  /** Abrir directamente el alta en la pantalla de destino. */
  nuevo?: boolean;
  /** Adónde volver al guardar, si la pantalla de destino lo admite. */
  volver?: string;
}) {
  const navegar = useNavigate();
  const consulta = new URLSearchParams();
  if (nuevo) consulta.set('nuevo', '1');
  if (volver) consulta.set('volver', volver);
  const href =
    consulta.size > 0 ? `${destino}?${consulta.toString()}` : destino;

  return (
    <p className="nota falta-antes" role="note">
      {children}{' '}
      <button
        type="button"
        className="enlace-fila"
        onClick={() => void navegar({ href })}
      >
        {accion} →
      </button>
    </p>
  );
}
